/**
 * Color Palettes for Charts
 * Blockchain-aware pastel color system inspired by primary assets
 */

// Pastel color palettes for different blockchains
export const BLOCKCHAIN_PALETTES = {
  BTC: ['#FFE29A', '#FFD166', '#FBBF77', '#F4976C', '#E76F51'],  // Yellow → Orange → Red
  ETH: ['#E3F2FD', '#CFE8FF', '#BBDCFB', '#A7D0F7', '#93C4F3'],  // Soft Blues
  SOL: ['#D8F3DC', '#BDE0FE', '#D0BDF4', '#C3F0CA', '#B8C0FF'],  // Green ↔ Purple
};

// Default mapping of tickers to their primary blockchain
export const TICKER_ASSET_MAP = {
  'MSTR': 'BTC',
  'BMNR': 'ETH',
  'BTBT': 'BTC',
  'BTCS': 'BTC',
  'SBET': 'BTC',
  'NAKA': 'BTC',
  'UPXI': 'BTC',
  'FORD': 'BTC',
  'SMLR': 'BTC',
  'HSDT': 'BTC',
  'CEP': 'BTC',
  'DFDV': 'BTC',
  'ETHZ': 'ETH',
};

/**
 * Generate a color map for multiple tickers based on their blockchain
 * @param {Array} tickers - Array of ticker symbols
 * @param {Object} tickerAssetMap - Optional custom ticker to blockchain mapping
 * @returns {Object} - Color map with ticker as key and color as value
 */
export const generateColorMap = (tickers, tickerAssetMap = TICKER_ASSET_MAP) => {
  const colorMap = {};
  
  // Bucket tickers by blockchain
  const buckets = { BTC: [], ETH: [], SOL: [] };
  
  tickers.forEach(ticker => {
    const blockchain = tickerAssetMap[ticker] || 'ETH'; // Default to ETH
    buckets[blockchain].push(ticker);
  });
  
  // Assign colors within each bucket
  Object.entries(buckets).forEach(([blockchain, tickerList]) => {
    const palette = BLOCKCHAIN_PALETTES[blockchain];
    tickerList.sort().forEach((ticker, index) => {
      colorMap[ticker] = palette[index % palette.length];
    });
  });
  
  return colorMap;
};

/**
 * Get a single color for a ticker based on its blockchain
 * @param {string} ticker - Ticker symbol
 * @param {number} index - Index for palette rotation
 * @returns {string} - Hex color code
 */
export const getTickerColor = (ticker, index = 0) => {
  const blockchain = TICKER_ASSET_MAP[ticker] || 'ETH';
  const palette = BLOCKCHAIN_PALETTES[blockchain];
  return palette[index % palette.length];
};

// Default chart color (cyan)
export const DEFAULT_CHART_COLOR = '#00ffff';

// Conditional colors for premium/discount
export const PREMIUM_DISCOUNT_COLORS = {
  positive: '#4CAF50',  // Green
  negative: '#F44336',  // Red
  neutral: '#9E9E9E',   // Gray
};


